import { Axios } from '@src/app/context/Api/includes/Axios';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';

/**
 * DeleteActionPath
 *
 * Deletes an action path from the remote API.
 *
 * @param payload
 * @returns {Promise<any>}
 * @constructor
 */
export const DeleteActionPath = async (payload = {}) => {
  try {
    const theApiKey = payload?.[0];
    const theMutationKey = payload?.[1];
    const thePayload = payload?.[2];

    const requestArgs = {
      baseURL: config('API_URL'),
      headers: {
        'x-api-endpoint': `/action-paths/${thePayload?.id}`,
      },
      method: 'delete',
      params: { apiKey: theApiKey, mutationKey: theMutationKey },
    };

    const remoteResponse = await Axios.request(requestArgs);

    return remoteResponse.data;
  } catch (error) {
    logger.error(
      'src/entities/ActionPath/api/requests/mutations/DeleteActionPath.js -> DeleteActionPath()',
      false,
      error
    );

    throw error;
  }
};
